<template>
    <v-card
        width="100%"
        height="100%"
        elevation="0"
    >
        <v-row
            no-gutters
            :class=" $vuetify.breakpoint.mdAndDown ? 'my-2' : 'ml-7 my-4'"
            :style="{'display': (message_details.messageText.email_subject && $vuetify.breakpoint.mdAndDown) ? 'none' : 'block'}"
        >
            <v-toolbar
                dense
                flat
            >
                <v-btn
                    icon
                    class="btn-back"
                    @click="$router.go(-1)"
                >
                    <v-icon class="material-icons-outlined">
                        chevron_left
                    </v-icon>
                </v-btn>
                <v-toolbar-title class="pl-3">
                    Messages
                </v-toolbar-title>
                <v-spacer />
            </v-toolbar>
        </v-row>
        <v-row
            v-if="message_details.messageText.email_subject && $vuetify.breakpoint.mdAndDown"
            no-gutters
            :class=" $vuetify.breakpoint.mdAndDown ? 'my-2' : 'ml-7 my-4'"
        >
            <v-toolbar
                dense
                flat
            >
                <v-btn
                    icon
                    class="btn-back"
                    @click="message_details.messageText.email_subject = null"
                >
                    <v-icon class="material-icons-outlined">
                        chevron_left
                    </v-icon>
                </v-btn>
                <v-toolbar-title class="pl-3">
                    {{ message_details.messageText.email_subject }}
                </v-toolbar-title>
                <v-spacer />
            </v-toolbar>
        </v-row>
        <v-divider
            :class=" $vuetify.breakpoint.mdAndDown ? '' : 'ml-7'"
        />
        <div
            v-if="userMessageView.total < 1"
            class="d-flex justify-center align-center"
            style="flex-direction: column; height: calc(100vh - 200px);"
        >
            <div class="mb-2">
                <MessageIcon />
            </div>
            <div class="subtitle-2">
                One-Call Center Broadcast Messages
            </div>
            <div class="caption email-content">
                There are no messages in your inbox.
            </div>
        </div>
        <div
            v-else
        >
            <v-row
                no-gutters
                :class="[userMessageView.total < 1 ? 'fill-height align-center' : '', $vuetify.breakpoint.mdAndDown ? '' : 'ml-7']"
                class="full-height md-4"
                style="flex-wrap: nowrap;"
                :style="{'border-left': $vuetify.breakpoint.mdAndDown ? 'none': '1px solid #e0e0e0'}"
            >
                <v-col
                    lg="4"
                    :style="{'display': (message_details.messageText.email_subject && $vuetify.breakpoint.mdAndDown) ? 'none' : 'block'}"
                >               
                    <div
                        class="subtitle-1 font-weight-bold pl-4 py-3"
                        :style="{'width': $vuetify.breakpoint.mdAndDown ? '100vw' : ''}"
                    >
                        One-Call Center Broadcast Messages
                    </div>
                    <v-data-iterator
                        :items="userMessageView.messages"
                        :search="search"
                        :items-per-page="-1"
                        hide-default-footer
                    >
                        <template v-slot:header>
                            <v-toolbar
                                dense
                                elevation="0"
                                class="mr-4"
                            >
                                <v-row no-gutters>
                                    <v-col
                                        cols="10"
                                        md="10"
                                    >
                                        <v-text-field
                                            v-model="search"
                                            clearable
                                            flat
                                            outlined
                                            dense
                                            hide-details
                                            append-icon="mdi-magnify"
                                            label="Search message"
                                        />
                                    </v-col>
                                    <v-spacer />
                                    <v-col
                                        cols="1"
                                        md="1"
                                    >
                                        <v-dialog
                                            v-model="dialog"
                                            width="400"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    v-bind="attrs"
                                                    :disabled="selectedRows.length <= 0"
                                                    color="primary"
                                                    outlined
                                                    small
                                                    style="height: 100%"
                                                    v-on="on"
                                                >
                                                    <v-icon>mdi-delete-outline</v-icon>
                                                </v-btn>
                                            </template>

                                            <v-card>
                                                <v-card-title class="text-subtitle-1 py-3 pl-5">
                                                    Delete
                                                </v-card-title>
                                                <v-divider />

                                                <v-card-text class="py-6 pl-5 pr-10">
                                                    {{ deleteDialogText }}
                                                </v-card-text>

                                                <v-divider />

                                                <v-card-actions>
                                                    <v-spacer />
                                                    <v-btn
                                                        outlined
                                                        color="indigo"
                                                        class="text-transform-none dialog-action-btn mr-2"
                                                        @click="dialog = false"
                                                    >
                                                        Cancel
                                                    </v-btn>

                                                    <v-btn
                                                        class="text-transform-none dialog-action-btn"
                                                        color="primary"
                                                        @click="deleteMessage"
                                                    >
                                                        Delete
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                        <!-- <v-btn
                                            :disabled="selectedRows.length < 1"
                                            color="primary"
                                            outlined
                                            small
                                            style="height: 100%"
                                        >
                                        </v-btn> -->
                                    </v-col>
                                </v-row>
                            </v-toolbar>
                            <v-row no-gutters>
                                <v-col cols="5">
                                    <div class="pl-4 py-2">
                                        <v-checkbox
                                            ref="selectAllCheckbox"
                                            v-model="selectAll"
                                            dense
                                            hide-details
                                            :indeterminate="
                                                selectedRows.length > 0 &&
                                                    selectedRows.length < userMessageView.total
                                            "
                                            @click="selectAllCheckBox()"
                                        >
                                            <template v-slot:label>
                                                <span class="grey--text text--darken-3">
                                                    Select All
                                                </span>
                                            </template>
                                        </v-checkbox>
                                    </div>
                                </v-col>
                            </v-row>
                        </template>
                        <v-list>
                            <v-list-item-group
                                ref="list"
                                multiple
                                class="overflow-scroll"
                            >
                                <template>
                                    <v-list-item
                                        v-for="(item, i) in userMessageView.messages"
                                        :key="i"
                                        style="border-top: 1px solid #e0e0e0;"
                                        :class="[ isActive(item.isOpen), item.message_read === 'true' ? 'm-read' : '' ]"
                                    >
                                        <v-list-item-action>
                                            <v-checkbox
                                                v-model="userMessageView.messages[i].selected"
                                                dense
                                                @click="selectSingleCheckBox(item)"
                                            />
                                        </v-list-item-action>
                                        <v-list-item-content
                                            @click="viewMessage(item); getMessage(item.rowid)"
                                        >
                                            <v-list-item-subtitle
                                                class="font-weight-medium  pr-16"
                                                :class="
                                                    item.message_read === 'false'
                                                        ? 'font-weight-bold'
                                                        : ''
                                                "
                                            >
                                                {{ item.subject }}
                                            </v-list-item-subtitle>
                                            <v-list-item-subtitle class="py-3">
                                                {{
                                                    formatMessageDate(item.received)
                                                }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-btn
                                            v-if="item.message_read === 'false'"
                                            icon
                                            large
                                        >
                                            <v-icon
                                                style="color: #F26227;"
                                                large
                                            >
                                                mdi-circle-medium
                                            </v-icon>
                                        </v-btn>
                                        <v-btn
                                            v-if="!$vuetify.breakpoint.smAndUp"
                                            icon
                                            @click="viewMessage(item)"
                                        >
                                            <v-icon>mdi-chevron-right</v-icon>
                                        </v-btn>
                                    </v-list-item>
                                </template>
                            </v-list-item-group>
                        </v-list>
                    </v-data-iterator>
                </v-col>
                <v-divider vertical />
                <template v-if="message_details.messageText.email_subject">
                    <v-col
                        style="margin-top:28px;" 
                        :class="'read-message-container-mobile' ? $vuetify.breakpoint.mdAndDown : ''"
                    >
                        <div
                            style="margin-left: 20px;font-family: Roboto;font-style: normal;font-weight: 500;font-size: 14px;line-height: 20px;left: 30px;top: 500px;position:static; left:450px"
                        >
                            {{ message_details.messageText.email_subject }}                                          
                            <v-dialog
                                v-model="dialog"
                                :class="userMessageView"
                                width="400"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        color="primary"
                                        outlined
                                        small 
                                        style="float:right;top:10px;border:none;outline:none; margin-right:28px"
                                        v-on="on"
                                    >
                                        <v-icon>mdi-delete-outline</v-icon>
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title class="text-subtitle-1 py-3 pl-5">
                                        Delete
                                    </v-card-title>
                                    <v-divider />

                                    <v-card-text class="py-6 pl-5 pr-10">
                                        Are you sure you want to delete "{{ message_details.messageText.email_subject }} " from the message list?
                                    </v-card-text>

                                    <v-divider />

                                    <v-card-actions>
                                        <v-spacer />
                                        <v-btn
                                            outlined
                                            color="indigo"
                                            class="text-transform-none dialog-action-btn mr-2"
                                            @click="dialog = false"
                                        >
                                            Cancel
                                        </v-btn>

                                        <v-btn
                                            class="text-transform-none dialog-action-btn"
                                            color="primary"
                                            @click="deleteSingleMessage(message_details.message)"
                                        >
                                            Delete
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                                                
                            <br>
                        </div>
                        <div>                    
                            <div class="email">
                                {{ message_details.messageText.email_received }}<br>
                            </div>
                            <div class="email">
                                To: {{ message_details.messageText.email_to }}<br>
                            </div>
                            
                            <v-divider
                                inset
                                style="margin-left:20px;margin-right:28px;margin-top:9px"
                            />
                            <pre style="margin-left:20px;margin-top:20px;font-size: 12px;font-family: Roboto;width: 80%;overflow:auto;">
                                {{ '\r\n' + message_details.messageText.email_body }}
                            </pre>
                        </div>
                    </v-col>
                </template>
                <template v-if="!message_details.messageText.email_subject && !$vuetify.breakpoint.mdAndDown">
                    <div
                        class="text-center d-flex justify-center align-center"
                        style="flex-direction: column; width: 66.66%"
                    >
                        <div class="mb-2">
                            <MessageIcon />
                        </div>
                
                        <div class="caption email-content">
                            No messages selected.
                        </div>
                    </div>
                </template>
            </v-row>
        </div>  
    </v-card>
</template>
<script>
import moment from 'moment';
import webtmsBackend from '@/services/webtmsBackend.js';
import MessageIcon from '@/components/CustomIcons/MessageIcon';
import { guidEqual } from '@/utils/guid.js';

export default {
    components: {
        MessageIcon
    },
    data() {
        return {
            search: '',
            selected: [],
            selectAll: false,
            dialog: false,
            message_details:{'message':{}, 'messageText':{'email_subject':''}},
            userMessageViewList: []
        };
    },
    computed: {
        userMessageView() {
            let messages = this.$store.getters.userMessagesView;
            return messages;
        },
        selectedRows() {
            return this.userMessageView.messages.filter((msg) => {
                if (msg.selected) {
                    return msg;
                }
            });
        },
        deleteDialogText: function () {
            if (!this.selectedRows.length) {
                return '';
            } else {
                return this.selectedRows.length == 1
                    ? `Are you sure you want to delete “${this.selectedRows[0].subject}” from the message list?`
                    : `Are you sure you want to delete ${this.selectedRows.length} messages from the message list?`;
            }
        },
    },
    created() {
        this.getMessagesList();
    },
    methods: {
        async dismissMessage(message) {
            await webtmsBackend.dismissUnreadMessage(message);
        },
        formatMessageDate(date) {
            return moment(date).format('MM/DD/YYYY, hh:mm:ss A');
        },
        async viewMessage(message) {
            message.message_read = 'true';
            this.userMessageView.messages = this.userMessageView.messages.map((item) => {
                if(guidEqual(item.rowid, message.rowid)) {
                    item.isOpen = true;
                } else {
                    item.isOpen = false;
                }
                return item;
            });
            this.$store.commit('SET_USER_MESSAGES_VIEW', this.userMessageView);
            await this.updateUserMessageViewCounts();
        },
        async getMessage(row_id) {
            this.message_details = await webtmsBackend.getCompanyMessage(row_id);
            return this.message_details;
        },
        async getMessagesList() {
            this.userMessageViewList = await webtmsBackend.getUserMessagesView();
            this.userMessageViewList = this.userMessageViewList.map(item => {
                item.selected = false;
                item.isOpen = false;
                return item;
            });
            this.$store.commit('SET_USER_MESSAGES_VIEW', this.userMessageViewList);
        },
        async deleteMessage() {
            this.selectedRows.forEach(async (message) => {
                this.dialog = false;
                this.userMessageView.messages = this.userMessageView.messages.filter((item) => !guidEqual(item.rowid, message.rowid));
                await webtmsBackend.deleteMessage(message.rowid);
                await this.updateUserMessageViewCounts();
                this.message_details = {'message':{}, 'messageText':{'email_subject':''}};
                this.$store.commit('SET_USER_MESSAGES_VIEW', this.userMessageView);
            });
        },
        async deleteSingleMessage(message) {
            this.dialog = false;
            this.userMessageView.messages = this.userMessageView.messages.filter((item) => !guidEqual(item.rowid, message.rowid));
            await webtmsBackend.deleteMessage(message.rowid);
            await this.updateUserMessageViewCounts();
            this.message_details = {'message':{}, 'messageText':{'email_subject':''}};
            this.$store.commit('SET_USER_MESSAGES_VIEW', this.userMessageView);
        },
        selectAllCheckBox() {
            var checked = [];
            this.userMessageView.messages = this.userMessageView.messages.map((message) => {
                message.selected = this.selectAll;
                if(this.selectAll) {
                    checked.push(message.rowid);
                }
                return message;
            });
            this.$store.commit('SET_USER_MESSAGES_VIEW', this.userMessageView);
            this.selected = checked;
        },
        selectSingleCheckBox(item) {
            if(item.isOpen) {
                item.isOpen = true;    
            } else {
                item.isOpen = false;
            }
            var selectedMessages = this.userMessageView.messages.filter((msg) => {
                if (msg.selected) {
                    return msg;
                }
            });
            this.$store.commit('SET_USER_MESSAGES_VIEW', this.userMessageView);
            if (selectedMessages.length === this.userMessageView.messages.length) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        },
        async deleteSelectedMessages() {
            this.selectedRows.forEach((msg)=>{
                this.userMessageView.messages.splice(this.userMessageView.messages.indexOf(msg), 1);
            });
            await this.updateUserMessageViewCounts();
            this.$store.commit('SET_USER_MESSAGES_VIEW', this.userMessageView);
            this.dialog = false;
        },
        async updateUserMessageViewCounts() {
            this.userMessageView.unread = 0;
            this.userMessageView.messages.forEach((msg)=>{
                if(msg.message_read === 'false') {
                    this.userMessageView.unread++;
                }
            });
            this.$store.commit('SET_USER_MESSAGES_VIEW', this.userMessageView);
            this.userMessageView.total = this.userMessageView.messages.length;
        },
        isActive(item) {
            return item !== undefined && item !== null && item !== false  ? 'bg-active' : '';
        }
    },
};
</script>
<style scoped>
.btn-back{
    border-radius: 50% !important;
    height: 32px !important;
    width: 32px !important;
    background: #F5F7FA;
}
.v-list-item:hover::before,
.v-list-item:focus::before,
.v-list-item--active::before {
  opacity: 0;
}

.full-height {
  height: calc(100vh - 140px);
}
.overflow-scroll {
  overflow-y: auto;
  max-height: calc(100vh - 310px);
}

.list-item-padding {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
}
.m-read{
    background:#F5F7FA;
}

.email {
position: static;
width: 212px;
height: 20px;
left: 0px;
top: 48px;
margin-left: 20px;
/* Caption 12/ Regular */

font-family: Roboto;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 20px;
color: #7F8592;
}
.bg-active {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F26227;
    box-shadow: inset 0px 1px 0px #E4E7ED;
}
.read-message-container-mobile {
    min-width: 100vw !important;
    height: calc(100vh + 400px) !important;
}
.height-100vh {
    height: 100vh;
}
.border-bottom {
    border-bottom: 1px solid #e0e0e0;
}
.email-content {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #7F8592;
}
</style>